module.exports = __webpack_public_path__ + "diamond-image03.png?411b2ca7ea69365977332dff889a45a2";